var _defs, _polygon, _path, _polygon2, _polygon3, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnlook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 164 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        mask: url(#mask-1);\n      }\n\n      .cls-3 {\n        mask: url(#mask);\n      }\n\n      .cls-4 {\n        stroke: #01c37d;\n        stroke-width: 10px;\n      }\n\n      .cls-4, .cls-5 {\n        fill: #01c37d;\n      }\n    "), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 70.72,
    y: -3.999,
    width: 37.443,
    height: 37.484,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path-11-inside-1_452_612",
    "data-name": "path-11-inside-1 452 612"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m75.72,14.743c0,3.268,1.163,6.429,3.28,8.916,2.117,2.487,5.05,4.137,8.273,4.653,3.222.516,6.523-.134,9.31-1.835,2.787-1.701,4.877-4.34,5.896-7.445,1.018-3.105.898-6.472-.338-9.496-1.236-3.024-3.509-5.509-6.409-7.007-2.9-1.498-6.239-1.912-9.416-1.167-3.178.745-5.986,2.599-7.921,5.23l11.048,8.15h-13.722Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 99.183,
    y: -3.999,
    width: 37.444,
    height: 37.484,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path-12-inside-2_452_612",
    "data-name": "path-12-inside-2 452 612"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m131.627,14.743c0,3.268-1.163,6.429-3.281,8.916-2.117,2.487-5.05,4.137-8.272,4.653-3.223.516-6.523-.134-9.31-1.835-2.786-1.701-4.877-4.34-5.895-7.445-1.019-3.105-.899-6.472.337-9.496,1.237-3.024,3.509-5.509,6.409-7.007,2.901-1.498,6.239-1.912,9.416-1.167,3.178.745,5.986,2.599,7.922,5.23l-11.048,8.15h13.722Z"
  }))))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "72.337 29.999 53.287 29.999 53.287 1.799 61.807 1.799 61.807 21.959 72.337 21.959 72.337 29.999"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m49.903,29.999h-8.52s-4.61-7.33-5.52-8.93c0,0-.05,7.31,0,8.93h-8.52V1.799h8.52c.51.91,5.38,12.11,5.52,12.36V1.799h8.52c-.05,3.42-.05,26.58,0,28.2Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "23.96 29.999 15.57 29.999 12.38 10.899 9.19 29.999 .79 29.999 5.31 1.739 19.45 1.739 23.96 29.999"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "163.21 29.999 151.22 29.999 143.53 22.309 143.53 29.999 135.01 29.999 135.01 1.819 143.53 1.819 143.53 9.509 151.22 1.819 162.98 1.819 149.18 15.909 163.21 29.999"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m75.72,14.743c0,3.268,1.163,6.429,3.28,8.916,2.117,2.487,5.05,4.137,8.273,4.653,3.222.516,6.523-.134,9.31-1.835,2.787-1.701,4.877-4.34,5.896-7.445,1.018-3.105.898-6.472-.338-9.496-1.236-3.024-3.509-5.509-6.409-7.007-2.9-1.498-6.239-1.912-9.416-1.167-3.178.745-5.986,2.599-7.921,5.23l11.048,8.15h-13.722Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m131.627,14.743c0,3.268-1.163,6.429-3.281,8.916-2.117,2.487-5.05,4.137-8.272,4.653-3.223.516-6.523-.134-9.31-1.835-2.786-1.701-4.877-4.34-5.895-7.445-1.019-3.105-.899-6.472.337-9.496,1.237-3.024,3.509-5.509,6.409-7.007,2.901-1.498,6.239-1.912,9.416-1.167,3.178.745,5.986,2.599,7.922,5.23l-11.048,8.15h13.722Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "103.673 21.362 107.986 25.68 103.673 29.999 99.361 25.68 103.673 21.362"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnlook);
export default __webpack_public_path__ + "static/media/Anlook.50ee8e35b3243bf8719f78fdfc49faa2.svg";
export { ForwardRef as ReactComponent };